import { useLocation, useNavigate } from 'react-router';
import { withRecord } from '../lib/links';
import { LeadDrawer } from './leads/LeadDrawer';
import { CustomerDrawer } from './sales/CustomerDrawer';

/**
 * The lead / customer side panel, on any page: `?lead=<id>` or `?customer=<id>` in the address.
 * Opening one from inside another (a quotation's customer, a customer's lead) replaces it.
 */
export function RecordPanels() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);
  const lead = params.get('lead');
  const customer = params.get('customer');
  const go = (kind: 'lead' | 'customer', id: string | null) =>
    navigate({ pathname: location.pathname, search: withRecord(location.search, kind, id) }, { replace: !id });
  return (
    <>
      {lead && <LeadDrawer key={lead} id={lead} onClose={() => go('lead', null)} onOpenLead={(id) => go('lead', id)} />}
      {customer && <CustomerDrawer key={customer} id={customer} onClose={() => go('customer', null)} />}
    </>
  );
}
